var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Setores de impressão","p-read-link":"print.read.one","p-create-link":"print.create","p-name":"imp-sector"}})}
var staticRenderFns = []

export { render, staticRenderFns }